import "./App.css";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";
import PriceTable from "./components/Prices/PriceTable";
import EditPage from "./components/Prices/EditPage";
import ExcelData from "./components/ExcelData";
import LintCottonForm from "./components/LintCotton/LintCottonForm";
import LintCottonTable from "./components/LintCotton/LintCottonTable";
import EditLintCotton from "./components/LintCotton/EditLintCotton";
import RatesInputPage from "./components/Prices/RatesInputPage";
import SowingForm from "./components/Sowing/SowingForm";
import IntentionForm from "./components/Intention/IntentionForm";
import CropConditionForm from "./components/CropCondition/CropConditionForm";
import SowingTable from "./components/Sowing/SowingTable";
import IntentionTable from "./components/Intention/IntentionTable";
import CropConditionTable from "./components/CropCondition/CropConditionTable";
import EditSowing from "./components/Sowing/EditSowing";
import EditIntention from "./components/Intention/EditIntention";
import EditCropCondition from "./components/CropCondition/EditCropCondition";
import AgronForm from "./components/Agron/AgronForm";
import EditAgron from "./components/Agron/EditAgron";
import AgronTable from "./components/Agron/AgronTable";
import ExportInputPage from "./components/ImportExport/ExportInputPage";
import ImportInputPage from "./components/ImportExport/ImportInputPage";
import PCGAInputPage from "./components/PCGA/PCGAInputPage";
import ImportTable from "./components/ImportExport/ImportTable";
import ExportTable from "./components/ImportExport/ExportTable";
import PCGATable from "./components/PCGA/PCGATable";
import KCASpotRateForm from "./components/KCASpotRate/KCASpotRateForm";
import KCASpotRateTable from "./components/KCASpotRate/KCASpotRateTable";
import EditKCASpotRate from "./components/KCASpotRate/EditKCASpotRate";
import BalanceSheetForms from "./components/BalanceSheet/BalanceSheetForms";
import EditBalanceSheet from "./components/BalanceSheet/EditBalanceSheet";
import BalanceSheetTable from "./components/BalanceSheet/BalanceSheetTable";
import MillConsumptionForm from "./components/MillConsumption/MillConsumptionForm";
import EditMillConsumption from "./components/MillConsumption/EditMillConsumption";
import MillConsumptionTable from "./components/MillConsumption/MillConsumptionTable";
import Imports from "./components/NewGraphs/Imports";
import Exports from "./components/NewGraphs/Exports";
// import PCGA from './components/NewGraphs/PCGA';
import ImageForm from "./components/ImageData/ImageForm";
import ImageTable from "./components/ImageData/ImageTable";
import Login from "./components/Login";
import Home from "./components/Home";
import SignupForm from "./components/SignupForm";
import NewsInput from "./components/NewsData/NewsInput";
import EditNews from "./components/NewsData/EditNews";
import NewsTable from "./components/NewsData/NewsTable";
import BlogsInput from "./components/Blogs/BlogsInput";
import BlogsTable from "./components/Blogs/BlogsTable";
import EditBlogs from "./components/Blogs/EditBlogs";
import SowingExcelUpload from "./components/Sowing/SowingExcelUpload";
import AgronExcelUpload from "./components/Agron/AgronExcelUpload";
import CropConditionExcelUpload from "./components/CropCondition/CropConditionExcelUpload";
import PriceFormProduct from "./components/MultiProductPerStation/PriceFormProduct";
import MetricConversions from "./components/NewGraphs/MetricConversions";
import SugarInput from "./components/Prices/SugarInput";
import WheatInputForm from "./components/Wheat/WheatInputForm";
import { SpiceInputForm } from "./components/Spices/SpiceInputForm";
import { PulsesInputForm } from "./components/Pulses/PulsesInputForm";
import PulsesTable from "./components/Pulses/PulsesTable";
import SpicesTable from "./components/Spices/SpicesTable";
import WheatTable from "./components/Wheat/WheatTable";
import SugarTable from "./components/SugarMillsSection/SugarTable";
import { RiceInputForm } from "./components/Prices/RiceInputForm";
import { EdibleOilsInputForm } from "./components/EdibleOilsInputForm";
import { MaizeInputForm } from "./components/Prices/MaizeInputForm";
import { FarmGradeRates } from "./components/FarmGradeRates";
import { CombinedPrice } from "./components/Prices/CombinedPrice";
import Display from "./components/Display";
import { CropCalendar } from "./components/NewGraphs/CropCalendar";
import { CropCalendarForm } from "./components/NewGraphs/CropCalendarForm";
import ClientDemoForm from "./components/ContactFormsWebflow/ClientDemoForm";
import ContactTable from "./components/ContactFormsWebflow/ContactTable";
import CropAdvisoryRequirementsTable from "./components/ContactFormsWebflow/CropAdvisoryRequirementsTable";
import FarmersRequirementsTable from "./components/ContactFormsWebflow/FarmersRequirementsTable";
import OtherCommoditiesRequirementsTable from "./components/ContactFormsWebflow/OtherCommoditiesRequirementsTable";
import ReportsDownloadInfo from "./components/ContactFormsWebflow/ReportsDownloadInfo";
import PaymentPricingForm from "./components/PaymentPricing/PaymentPricingForm";
import PaymentPricingTable from "./components/PaymentPricing/PaymentPricingTable";
import PaymentPricingUpdate from "./components/PaymentPricing/PaymentPricingUpdate";
import EditSugar from "./components/Prices/EditSugar";
import SugarMillsForm from "./components/SugarMillsSection/SugarMillsForm";
import SugarMillsFormUpdate from "./components/SugarMillsSection/SugarMillsFormUpdate";
import AkbariMandiTable from "./components/SugarJodiaAkbari/AkbariMandi/AkbariMandiTable";
import JodiaBazarTable from "./components/SugarJodiaAkbari/JodiaBazar/JodiaBazarTable";
import AkbariMandiCreate from "./components/SugarJodiaAkbari/AkbariMandi/AkbariMandiCreate";
import AkbariMandiUpdate from "./components/SugarJodiaAkbari/AkbariMandi/AkbariMandiUpdate";
import JodiaBazarCreate from "./components/SugarJodiaAkbari/JodiaBazar/JodiaBazarCreate";
import JodiaBazarUpdate from "./components/SugarJodiaAkbari/JodiaBazar/JodiaBazarUpdate";
import PriceFormDates from "./components/MultiProductPerStation/PriceFormDates";
import PriceFormSpices from "./components/MultiProductPerStation/PriceFormSpices";
import PriceFormHerbals from "./components/MultiProductPerStation/PriceFormHerbals";
import ReportRoutes from "./components/Reports/ReportRoutes";
import HeadingComponent from "./components/SEO/Heading/HeadingComponent";
import HeadingFormComponent from "./components/SEO/Heading/HeadingFormComponent";
import NewsVoiceUpload from "./components/NewsVoice/NewsVoiceUpload";
import NewsVoiceList from "./components/NewsVoice/NewsVoiceList";
// import Reports from './components/Reports/Reports';
// import ReportsInput from './components/Reports/ReportsInput';
// import WeeklyWaterAndWeatherReport from './components/WeeklyWaterAndWeatherReport';
function ProtectedRoute({ children }) {
  const isAuthenticated = sessionStorage.getItem("token") !== null;

  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <BrowserRouter>
      <ReportRoutes />

      <div className="container">
        <div className="content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignupForm />}></Route>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route path="/prices" element={<PriceTable />} />
            <Route
              path="/update/:_id"
              element={
                <ProtectedRoute>
                  <EditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/updatelintcotton/:_id"
              element={
                <ProtectedRoute>
                  <EditLintCotton />
                </ProtectedRoute>
              }
            />
            <Route
              path="/uploadexcel"
              element={
                <ProtectedRoute>
                  <ExcelData />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lintcotton-form"
              element={
                <ProtectedRoute>
                  <LintCottonForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lintcotton"
              element={
                <ProtectedRoute>
                  <LintCottonTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inputrates"
              element={
                <ProtectedRoute>
                  <RatesInputPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sowing-form"
              element={
                <ProtectedRoute>
                  <SowingForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/intention-form"
              element={
                <ProtectedRoute>
                  <IntentionForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cropcondition-form"
              element={
                <ProtectedRoute>
                  <CropConditionForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sowing"
              element={
                <ProtectedRoute>
                  <SowingTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/intention"
              element={
                <ProtectedRoute>
                  <IntentionTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-sowing/:_id"
              element={
                <ProtectedRoute>
                  <EditSowing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-intention/:_id"
              element={
                <ProtectedRoute>
                  <EditIntention />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-cropcondition/:_id"
              element={
                <ProtectedRoute>
                  <EditCropCondition />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cropcondition"
              element={
                <ProtectedRoute>
                  <CropConditionTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agron-form"
              element={
                <ProtectedRoute>
                  <AgronForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-agron/:_id"
              element={
                <ProtectedRoute>
                  <EditAgron />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agron"
              element={
                <ProtectedRoute>
                  <AgronTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inputexports"
              element={
                <ProtectedRoute>
                  <ExportInputPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inputimports"
              element={
                <ProtectedRoute>
                  <ImportInputPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inputPCGA"
              element={
                <ProtectedRoute>
                  <PCGAInputPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/import"
              element={
                <ProtectedRoute>
                  <ImportTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/export"
              element={
                <ProtectedRoute>
                  <ExportTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/PCGA"
              element={
                <ProtectedRoute>
                  <PCGATable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kca-spot-rate-form"
              element={
                <ProtectedRoute>
                  <KCASpotRateForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/KCA"
              element={
                <ProtectedRoute>
                  <KCASpotRateTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-KCA/:_id"
              element={
                <ProtectedRoute>
                  <EditKCASpotRate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/balance-sheet-form"
              element={
                <ProtectedRoute>
                  <BalanceSheetForms />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-balance-sheet/:_id"
              element={
                <ProtectedRoute>
                  <EditBalanceSheet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/balance-sheet"
              element={
                <ProtectedRoute>
                  <BalanceSheetTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-mill-consumption/:_id"
              element={
                <ProtectedRoute>
                  <EditMillConsumption />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mill-consumption"
              element={
                <ProtectedRoute>
                  <MillConsumptionTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mill-consumption-form"
              element={
                <ProtectedRoute>
                  <MillConsumptionForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/image-input"
              element={
                <ProtectedRoute>
                  <ImageForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/images"
              element={
                <ProtectedRoute>
                  <ImageTable />
                </ProtectedRoute>
              }
            />
            <Route path="/news-input" element={<NewsInput />} />
            <Route path="/news" element={<NewsTable />} />
            <Route path="/update-news/:_id" element={<EditNews />} />
            <Route path="/blogs-input" element={<BlogsInput />} />
            <Route path="/blogs" element={<BlogsTable />} />
            {/* <Route path='/reports' element={<Reports/>}/> */}
            {/* <Route path='/reports-input' element={<ReportsInput/>}/> */}
            {/* <Route path='/reports-input' element={<ReportsInput/>}/> */}
            {/* <Route path='/reports-generate' element={<WeeklyWaterAndWeatherReport/>}/> */}

            <Route path="/update-blogs/:_id" element={<EditBlogs />} />
            <Route
              path="/sowing-excel-upload"
              element={<SowingExcelUpload />}
            />
            <Route path="/agron-excel-upload" element={<AgronExcelUpload />} />
            <Route
              path="/crop-condition-excel-upload"
              element={<CropConditionExcelUpload />}
            />
            <Route path="/impo-dash" element={<Imports />} />
            <Route path="/expo-dash" element={<Exports />} />
            <Route path="/pfp" element={<PriceFormProduct />} />
            <Route
              path="/multiple-dates-per-station"
              element={<PriceFormDates></PriceFormDates>}
            ></Route>
            <Route
              path="/multiple-spices-per-station"
              element={<PriceFormSpices></PriceFormSpices>}
            ></Route>
            <Route
              path="/multiple-herbals-per-station"
              element={<PriceFormHerbals></PriceFormHerbals>}
            ></Route>
            <Route path="/metric-conversion" element={<MetricConversions />} />
            <Route path="/sugar-input" element={<SugarInput />} />
            <Route path="/wheat-input" element={<WheatInputForm />}></Route>
            <Route path="/spice-input" element={<SpiceInputForm />}></Route>
            <Route path="/pulse-input" element={<PulsesInputForm />}></Route>
            <Route path="/rice-input" element={<RiceInputForm />}></Route>
            <Route
              path="/edible-oils-input"
              element={<EdibleOilsInputForm />}
            ></Route>
            <Route path="/maize-input" element={<MaizeInputForm />}></Route>
            <Route
              path="/farm-grade-input"
              element={<FarmGradeRates />}
            ></Route>
            <Route path="/pulses" element={<PulsesTable />}></Route>
            <Route path="/spices" element={<SpicesTable />}></Route>
            <Route path="/wheat" element={<WheatTable />}></Route>
            <Route path="/sugar" element={<SugarTable />}></Route>
            <Route path="/combined-price" element={<CombinedPrice />}></Route>
            <Route path="/display" element={<Display />}></Route>
            <Route path="/crop-calendar" element={<CropCalendar />}></Route>
            <Route path="/client-demo" element={<ClientDemoForm />}></Route>
            <Route path="/calendar-form" element={<CropCalendarForm />}></Route>
            <Route path="/sugar-mill-data" element={<SugarTable />}></Route>
            <Route path="/edit-sugar/:_id" element={<EditSugar />}></Route>
            <Route
              path="/sugar-mill-price"
              element={<SugarMillsForm></SugarMillsForm>}
            ></Route>
            <Route
              path="/sugar-mill-price-update/:_id"
              element={<SugarMillsFormUpdate></SugarMillsFormUpdate>}
            ></Route>
            <Route
              path="/jodia-bazar"
              element={<JodiaBazarTable></JodiaBazarTable>}
            ></Route>
            <Route
              path="/jodia-bazar-form"
              element={<JodiaBazarCreate></JodiaBazarCreate>}
            ></Route>
            <Route
              path="/jodia-bazar-update/:_id"
              element={<JodiaBazarUpdate></JodiaBazarUpdate>}
            ></Route>
            <Route
              path="/akbari-mandi"
              element={<AkbariMandiTable></AkbariMandiTable>}
            ></Route>
            <Route
              path="/akbari-mandi-form"
              element={<AkbariMandiCreate></AkbariMandiCreate>}
            ></Route>
            <Route
              path="/akbari-mandi-update/:_id"
              element={<AkbariMandiUpdate></AkbariMandiUpdate>}
            ></Route>
            {/* <Route path='/faq-page' element={<FAQApp></FAQApp>}></Route> */}
            <Route
              path="/payment-pricing-form"
              element={<PaymentPricingForm></PaymentPricingForm>}
            ></Route>
            <Route
              path="/payment-pricing-table"
              element={<PaymentPricingTable></PaymentPricingTable>}
            ></Route>
            <Route
              path="/payment-pricing-update/:id"
              element={<PaymentPricingUpdate></PaymentPricingUpdate>}
            ></Route>
            {/**Website Forms*/}
            <Route path="/contact-message" element={<ContactTable />}></Route>
            <Route
              path="/crop-advisory-requirements"
              element={<CropAdvisoryRequirementsTable />}
            />
            <Route
              path="/farmers-data"
              element={<FarmersRequirementsTable></FarmersRequirementsTable>}
            ></Route>
            <Route
              path="/other-commodities-data"
              element={<OtherCommoditiesRequirementsTable />}
            ></Route>
            <Route path="/report-downloads" element={<ReportsDownloadInfo />} />
            <Route path="/seo-pages" element={<HeadingComponent />} />
            <Route
              path="/seo-pages/create"
              element={<HeadingFormComponent />}
            />
            <Route
              path="/seo-pages/edit/:id"
              element={<HeadingFormComponent />}
            />
             <Route
              path="/news-voice-upload"
              element={<NewsVoiceUpload />}
            />
             <Route
              path="/news-voice"
              element={<NewsVoiceList />}
            />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
